const IGNORED_ERROR_MESSAGES = [
  /ResizeObserver loop/i,
  /Non-Error promise rejection/i,
  /Network Error/i,
  /Load failed/i,
  /AbortError/i,
  /The operation was aborted/i,
  /cancelled/i,
  /canceled/i,
  /ChunkLoadError/i,
  /Failed to fetch dynamically imported module/i,
]

const BENIGN_HTTP_STATUSES = new Set([401, 403, 404, 408, 429])

export function isIgnoredErrorMessage(message: string | undefined): boolean {
  if (!message) return false
  return IGNORED_ERROR_MESSAGES.some((pattern) => pattern.test(message))
}

export function isBenignHttpError(error: unknown): boolean {
  const axiosLike = error as {
    isAxiosError?: boolean
    response?: { status?: number }
    code?: string
  }

  if (!axiosLike?.isAxiosError) return false

  const status = axiosLike.response?.status
  if (status && BENIGN_HTTP_STATUSES.has(status)) return true

  return axiosLike.code === "ERR_CANCELED" || axiosLike.code === "ECONNABORTED"
}

export function isCriticalHttpFailure(
  status: number,
  endpoint: string
): boolean {
  if (status >= 500 || status === 0) {
    return /(payment|checkout|login|identity|request_ride|place_order|marketplace)/i.test(
      endpoint
    )
  }

  return false
}

const recentEvents = new Map<string, number>()
const DEDUPE_WINDOW_MS = 60_000

export function shouldDedupeEvent(fingerprint: string): boolean {
  const now = Date.now()
  const lastSentAt = recentEvents.get(fingerprint)

  if (lastSentAt && now - lastSentAt < DEDUPE_WINDOW_MS) {
    return true
  }

  recentEvents.set(fingerprint, now)
  return false
}

export function buildEventFingerprint(
  parts: Array<string | number | undefined>
): string {
  return parts.filter(Boolean).join("|")
}
